import { assistancesObject } from '@/models/assistances'
const _ = require('lodash')

export default {
  newAssistance: _.cloneDeep(assistancesObject),
  updateAssistance: _.cloneDeep(assistancesObject),
  searchParams: '',
  vacationSearchParams: '',
}
